<template>
  <div class="StoreMethod">
    <vue-element-loading
      :active="show"
      is-full-screen
      text="Estamos generando su recibo, porfavor espere..."
    />
    <div class="whitepaper">
      <div class="Header">
        <div class="Logo_empresa">
          <!-- <img src="https://pay.gtek.mx/assets/recipt/logo.png" alt="Logo">-->
        </div>
        <div class="Logo_paynet">
          <div>Servicio a pagar</div>
          <img src="https://pay.gtek.mx/assets/recipt/paynet_logo.png" alt="Logo Paynet">
        </div>
      </div>
      <div class="Data">
        <div class="Big_Bullet">
          <span></span>
        </div>
        <div class="col1">
          <h3>Fecha límite de pago</h3>
          <h4>{{ date}}</h4>
          <img width="300" :src="barCode" alt="Código de Barras">
          <center>
            <span class="refNum">{{ numberCode }}</span>
          </center>
          <small>En caso de que el escáner no sea capaz de leer el código de barras, escribir la referencia tal como se muestra.</small>
        </div>
        <div class="col2">
          <h2>Total a pagar</h2>
          <h1>
            $ {{ total }}
            <small>MXN</small>
          </h1>
          <span
            class="note"
          >La comisión por recepción del pago varía de acuerdo a los términos y condiciones que cada cadena comercial establece.</span>
        </div>
      </div>
      <div class="DT-margin"></div>
      <div class="Data">
        <div class="Big_Bullet">
          <span></span>
        </div>
        <div class="col1">
          <h3>Detalles de la compra</h3>
        </div>
      </div>
      <div class="Table-Data">
        <div class="table-row color1">
          <div>Descripción</div>
          <span>{{ description}}</span>
        </div>
        <div class="table-row color2">
          <div>Fecha y hora</div>
          <span>{{ datePayment }}</span>
        </div>
        <div class="table-row color1">
          <div>Correo del cliente</div>
          <span>{{ email}}</span>
        </div>
        <div class="table-row color2" style="display:none">
          <div>&nbsp;</div>
          <span>&nbsp;</span>
        </div>
        <div class="table-row color1" style="display:none">
          <div>&nbsp;</div>
          <span>&nbsp;</span>
        </div>
      </div>
      <div class="DT-margin"></div>
      <div>
        <div class="Big_Bullet">
          <span></span>
        </div>
        <div class="col1">
          <h3>Como realizar el pago</h3>
          <ol>
            <li>Acude a cualquier tienda afiliada</li>
            <li>Entrega al cajero el código de barras y menciona que realizarás un pago de servicio Paynet</li>
            <li>Realizar el pago en efectivo por {{ total}}</li>
            <li>Conserva el ticket para cualquier aclaración</li>
          </ol>
          <!-- <small>Si tienes dudas comunícate a "NOMBRE EMPRESA" al teléfono TELEFONO EMPRESA o al correo CORREO SOPORTE TIENDA</small>-->
        </div>
        <div class="col1">
          <h3>Instrucciones para el cajero</h3>
          <ol>
            <li>Ingresar al menú de Pago de Servicios</li>
            <li>Seleccionar Paynet</li>
            <li>Escanear el código de barras o ingresar el núm. de referencia</li>
            <li>Ingresa la cantidad total a pagar</li>
            <li>Cobrar al cliente el monto total más la comisión</li>
            <li>Confirmar la transacción y entregar el ticket al cliente</li>
          </ol>
          <small>Para cualquier duda sobre como cobrar, por favor llamar al teléfono +52 (55) 5351 7371 en un horario de 8am a 9pm de lunes a domingo</small>
        </div>
      </div>

      <div class="logos-tiendas">
        <ul>
          <li>
            <img src="https://pay.gtek.mx/assets/recipt/01.png" width="100" height="50">
          </li>
          <li>
            <img src="https://pay.gtek.mx/assets/recipt/02.png" width="100" height="50">
          </li>
          <li>
            <img src="https://pay.gtek.mx/assets/recipt/03.png" width="100" height="50">
          </li>
          <li>
            <img src="https://pay.gtek.mx/assets/recipt/04.png" width="100" height="50">
          </li>
          <li>
            <img src="https://pay.gtek.mx/assets/recipt/05.png" width="100" height="50">
          </li>
          <li>
            <img src="https://pay.gtek.mx/assets/recipt/06.png" width="100" height="50">
          </li>
          <li>
            <img src="https://pay.gtek.mx/assets/recipt/07.png" width="100" height="50">
          </li>
          <li>
            <img src="https://pay.gtek.mx/assets/recipt/08.png" width="100" height="50">
          </li>
        </ul>
        <div
          style="height: 90px; width: 190px; float: right; margin-top: 30px;"
        >¿Quieres pagar en otras tiendas? visítanos en: www.openpay.mx/tiendas</div>
      </div>
      <div class="Powered">
        <img
          src="https://pay.gtek.mx/assets/recipt/powered_openpay.png"
          alt="Powered by Openpay"
          width="150"
        >
        <a @click.prevent="print" href="#">Imprimir</a>
        <a @click.prevent="close" href="#">Cerrar</a>
      </div>
    </div>
  </div>
</template>

<script>
import { servicesAR } from "@/components/services/servicesAR";
const moment = require("moment");

export default {
  name: "storeMethod",
  data: () => ({
    deviceSessionId: "",
    token_id: "",
    numberCode: "",
    barCode: "",
    total: "",
    description: "",
    date: "",
    email: "",
    datePayment: "",
    show: false
  }),
  props: {},
  computed: {
    cart() {
      return this.$store.state.cart;
    }
  },
  methods: {
    print() {
      window.print();
    },
    close() {
      var that = this;
      var msg = JSON.stringify({
        success: true,
        adTitle: that.cart.adTitle,
        pType: "2",
        adKey: that.cart.adKey
      });
      window.opener.postMessage(msg, "*");
      console.log(window.opener);

      window.close();
    }
  },
  async created() {
    this.show = true;
    var that = this;
    console.log("StoreMode");

    let clientData = JSON.stringify({
      amount: that.cart.adCost,
      description: that.cart.adTitle,
      adKey: that.cart.adKey
    });

    const recipt = await servicesAR.requestChargeStore(clientData);

    if (recipt.success == true) {
      this.numberCode = recipt.data.payment_method.reference;
      this.barCode = recipt.data.payment_method.barcode_url;
      this.total = recipt.data.amount;
      this.description = recipt.data.description;
      this.date = moment(
        recipt.data.due_date,
        "YYYY-MM-DDTHH:mm:ss-06:00"
      ).format("DD/MM/YYYY HH:MM");
      this.datePayment = moment(
        recipt.data.operation_date,
        "YYYY-MM-DDTHH:mm:ss-06:00"
      ).format("DD/MM/YYYY HH:MM");
      this.email = recipt.data.customer.email;
      console.log(recipt.data.customer);
    } else {
      alert("Error al generar la referencia");
    }
    this.show = false;
  }
};
</script>


<style scoped>
.refNum {
  font-size: 18px !important;
  font-weight: bold;
}
h3 {
  font-size: 25px;
  margin: 15px 0 0 0;
}
h4 {
  font-size: 17px;
  margin: 8px 0;
}
.whitepaper {
  background-color: #fff;
  width: 812px;
  height: 1123px;
  margin: 0 auto;
  border: #d8d8d8 1px solid;
}
.Header {
  clear: both;
  float: left;
  width: 84%;
  margin: 4% 8% 4% 8%;
}
.Logo_empresa img {
  width: 220px;
  float: left;
}
.Logo_paynet {
  float: right;
  margin-top: 3px;
}
.Logo_paynet div {
  font-size: 20px;
  font-weight: lighter;
  display: block;
  float: left;
  margin: 10px 12px 0 0;
}
.Logo_paynet img {
  width: 130px;
  float: left;
}
.Data {
  width: 100%;
  clear: both;
  float: left;
}
.DT-margin {
  margin: 15px 0;
  display: block;
  float: left;
  width: 100%;
  clear: both;
}
.Big_Bullet {
  width: 40px;
  float: left;
  margin-right: 24px;
}
.Big_Bullet span,
.col2 {
  background-color: #f9b317;
}
.Big_Bullet span {
  width: 100%;
  height: 55px;
  display: block;
}
.col1 {
  width: 350px;
  float: left;
}
.col1 span {
  font-size: 14px;
  clear: both;
  display: block;
  margin: 5px 0;
}
.col1 small {
  font-size: 12px;
  width: 320px;
  display: block;
}
.col2 {
  width: 358px;
  float: right;
  color: #fff;
  padding: 40px 0 40px 40px;
}
.col2 h1 {
  margin: 0;
  padding: 0;
  font-size: 60px;
}
.col2 h1 span {
  font-size: 45px;
}
.col2 h1 small {
  font-size: 20px;
}
.col2 h2 {
  margin: 0;
  font-size: 22px;
  font-weight: lighter;
}
.S-margin {
  padding-left: 80px;
}

.Table-Data {
  margin: 20px 0 0 0;
  clear: both;
  width: 100%;
  display: block;
  float: left;
}
.table-row {
  float: left;
  width: 83%;
  padding: 0 8.5%;
}
.table-row div {
  float: left;
  width: 250px;
  padding: 15px 0;
}
.table-row span {
  float: left;
  border-left: 3px solid #fff;
  padding: 15px 0 15px 40px;
}
.color1 {
  background-color: #f3f3f3;
}
.color2 {
  background-color: #ebebeb;
}

.col1 ol,
.Col2 ol {
  font-size: 12px;
  width: 290px;
  padding-left: 20px;
}
.col1 li,
.Col2 li {
  padding: 5px 0;
  line-height: 16px;
  text-align: left;
}
.logos-tiendas {
  clear: both;
  float: left;
  width: 92%;
  padding: 10px 0 10px 8%;
  border-top: 1px solid #ededed;
  border-bottom: 1px solid #ededed;
  margin: 0px 0 0 0;
}
.logos-tiendas div {
  float: left;
  margin-right: 50px;
}
.logos-tiendas small {
  font-size: 11px;
  margin-left: 20px;
  float: left;
}
.logos-tiendas ul {
  margin: 0;
  list-style: none;
  padding: 0;
  width: 480px;
  float: left;
}
.logos-tiendas li {
  float: left;
  margin: 10px 10px 0 10px;
}

.Powered {
  width: 100%;
  float: left;
  margin-top: 18px;
  margin-bottom: 30px;
}
.Powered img {
  margin-left: 65px;
  margin-right: 290px;
}
.Powered a {
  border-radius: 6px;
  background-color: #0075f0;
  padding: 7px 13px;
  color: #fff;
  font-size: 16px;
  font-weight: normal;
  text-decoration: none;
  margin: 10px;
}
.Powered a:hover {
  background-color: #009bff;
}

.note {
  font-size: 12px;
}
</style>